module.exports = __webpack_public_path__ + "img/csharp.aaad88d3.png";